










import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import Velocity from 'velocity-animate';

@Component
export default class DynamicNotification extends Vue {
    @Prop(String) variant: string;
    @Prop(Boolean) show: boolean;

    isShown = false;

    toggle() {
        this.isShown = !this.isShown;
    }

    @Watch('show')
    updateShown() {
        this.isShown = this.show;
    }

    animate(el, done) {
        Velocity(el, 'fadeIn', { duration: 10 });
        Velocity(el, {
            height: 0,
            paddingTop: 0,
            paddingBottom: 0,
            opacity: 0,
        }, { delay: 5000, duration: 500 }, { complete: done });
    }

    hide() {
        this.isShown = false;
    }
}
